/**
 * Logs console messages upon entering and exiting a function, including function parameters and return value.
 * By default, method entry and exit are logged, but can be selectively disabled by setting the related option to false when using the decorator.
 */
export function log(options = {logEntry: true, logExit: true}) {
  return function (target: any, key: string, descriptor: TypedPropertyDescriptor<any>): TypedPropertyDescriptor<any> {
    const originalMethod = descriptor.value as undefined | ((this: TypedPropertyDescriptor<any>, ...args: unknown[]) => unknown);

    descriptor.value = function (...args: unknown[]) {
      if (options.logEntry) console.log(`--> ${key}`, args); // , target);
      const result = originalMethod?.apply(this, args);
      if (options.logExit) console.log(`<-- ${key}`, result);

      return result;
    };

    return descriptor;
  };
}

/**
 * Measures how long a function takes to execute and logs the result in the console.
 */
export const measurePerformance = (target: unknown, key: string, descriptor: TypedPropertyDescriptor<any>): TypedPropertyDescriptor<any> => {
  const originalMethod = descriptor.value as undefined | ((this: TypedPropertyDescriptor<CallableFunction>, ...args: unknown[]) => unknown);

  descriptor.value = function (...args: unknown[]) {
    const startTime = window.performance.now();
    const result = originalMethod?.apply(this, args);
    const endTime = window.performance.now();

    console.log(`${originalMethod?.name}() took ${endTime - startTime} milliseconds to execute.`);

    return result;
  };

  return descriptor;
};
